import { render } from "./USWDSBanner.vue?vue&type=template&id=3c20d300"
import script from "./USWDSBanner.vue?vue&type=script&lang=js"
export * from "./USWDSBanner.vue?vue&type=script&lang=js"

import exportComponent from "/builds/wma/osd/decap/configuration-depot/configuration-depot-application/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__